module.exports = __webpack_public_path__ + "img/excellence_large.73cc10a8.png";